/** App-bound sign-in (PKCE style): the app keeps a secret `verifier` and shows the auth Worker only its SHA-256 `challenge` (apps/auth/src/handoff.ts). */

export function base64Url(bytes: Uint8Array): string {
  let binary = ''
  for (const byte of bytes) binary += String.fromCharCode(byte)
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

/** 32 random bytes = 43 characters of base64url, within RFC 7636's 43..128. */
export function createVerifier(randomBytes: (length: number) => Uint8Array = (length) => crypto.getRandomValues(new Uint8Array(length))): string {
  return base64Url(randomBytes(32))
}

/** RFC 7636 "S256": base64url(SHA-256(ASCII(verifier))). */
export async function challengeFor(verifier: string): Promise<string> {
  return base64Url(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))))
}
